const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";
const API_PATH = process.env.REACT_APP_API_PATH || "";

export const SERVER = `${API_PROTOCOL}://${API_HOST}/${API_PATH}`;

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  for (const key in process.env) {
    if (process.env.hasOwnProperty(key)) {
      const value = process.env[key];
    }
  }
}

export default { apiUrl: SERVER };
